import { Controller } from '@hotwired/stimulus'

// Used to make a bigger surface area for clickable element.
// Note the "checkbox" does not have to be a checkbox, it can be used for any clickable element

export default class extends Controller {
  static targets = ['checkbox']

  select(event) {
    let selector = event.target.closest('.selector')
    let id = selector.id.split('-')[1]
    this.checkboxTargets.forEach((checkbox) => {
      if (checkbox.id == `checkbox-${id}`) {
        if (!checkbox.isEqualNode(event.target)) {
          checkbox.click()
        }
      }
    })
  }
}